import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **CityEndpoint **
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas a carrito
 */
export class CheckoutEndpoint {
  static checkout = `${apiUrl}checkouts/`;
  static checkoutLines = `${apiUrl}checkouts_lines/`;
  static checkoutLinesByCheckout = `${apiUrl}checkouts_lines/data/`;
  static sale = `${apiUrl}sales/create/`;
  static epayco = 'https://secure.epayco.co/validation/v1/reference/';
}
